import React from "react";
import { Col, Row, Button, Input } from "reactstrap";
import ToolkitProvider, { CSVExport } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import SubuserInvoiceTableDropdown from "./subuserInvoiceTableDropdown";
import SubUserFilterCustom from "./subUserFilterCustom";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";

const SubuserInvoiceAdminViewTable = ({ tableData, searchQuery, defaultSorted, subUserData, setToggleModal, setDataModal, disabled, currentUser }) => {
  const { ExportCSVButton } = CSVExport;

  const currencies = ["€", "$", "£"];

  const amountFormatter = (cell, row) => `${cell}${currencies[row.currency]}`;

  const downloadFormatter = cell =>
    cell ? (
      <a href={cell} target="blank">
        <Button className="btn-status" color="primary" disabled={disabled}>
          <b>Download</b>
        </Button>
      </a>
    ) : null;

    const statusFormatter = cell => {
      //  0 => Pending
      //  1 => Accepted
      //  2 => Rejected
      //  3 => Paid
      //  4 => Generating
      return (
        <>
          {cell === 0 ? (
            <Button className="btn-status" disabled color="warning">
              Pending
            </Button>
          ) : cell === 1 ? (
            <Button className="btn-status" disabled color="success">
              Accepted
            </Button>
          ) : cell === 2 ? (
            <Button className="btn-status" disabled color="danger">
              Rejected
            </Button>
          ) : cell === 3 ? (
            <Button className="btn-status" disabled color="success">
              Paid
            </Button>
          ) : cell === 4 ? (
            <Button className="btn-status" disabled color="warning">
              Generating
            </Button>
          ) : null}
        </>
      );
    };

    const actionFormatter = (cell, row) => {
        return (
          <SubuserInvoiceTableDropdown
            data={row}
            setToggleModal={setToggleModal}
            setDataModal={setDataModal}
            disabled={disabled}
          />
        );
    };

  const columns = [
    {
      dataField: "issue_date",
      text: "Issue Date",
      sort: true,
      headerStyle: () => ({ width: "120px" })
    },
    {
      dataField: "invoice_number",
      text: "Invoice Number",
      sort: true,
      headerStyle: () => ({ width: "120px" })
    },
    {
      dataField: "owner",
      text: "Owner",
      sort: true,
      headerStyle: () => ({ width: "120px" })
    },
    {
      dataField: "gross_amount",
      text: "Gross Amount",
      sort: true,
      formatter: amountFormatter,
      csvFormatter: amountFormatter,
      headerStyle: () => ({ width: "120px" })
    },
    {
      dataField: "tax_amount",
      text: "Tax Amount",
      sort: true,
      formatter: amountFormatter,
      csvFormatter: amountFormatter,
      headerStyle: () => ({ width: "120px" })
    },
    {
      dataField: "net_amount",
      text: "Net Amount",
      sort: true,
      formatter: amountFormatter,
      csvFormatter: amountFormatter,
      headerStyle: () => ({ width: "120px" })
    },
    {
      dataField: "status",
      text: "Status",
      formatter: statusFormatter,
      sort: true,
      headerStyle: () => ({ width: "120px" })
    },
    {
      dataField: "invoice_pdf",
      text: "Download PDF",
      formatter: downloadFormatter,
      headerStyle: () => ({ width: "100px" })
    },
    {
      dataField: "action",
      text: "Action",
      formatter: actionFormatter,
      sort: false,
      csvExport: false,
      headerStyle: () => ({ width: "111px" })
    },
    {
      dataField: "name",
      sort: false,
      csvExport: false,
      hidden: true,
    }
  ];

  const handleTableChange = (type, { sortField, sortOrder }) => {
    const ascDesc = sortOrder === "desc" ? "-" : "";
    if (sortField === "issue_date" || sortField === "invoice_number" || sortField === "status" || sortField === "net_amount") {
      searchQuery.setOrdering({ order: ascDesc, name: sortField, sort: sortField });
    }
  };

  return (
    <ToolkitProvider
      keyField="id"
      data={tableData}
      columns={columns}
      search={{
        searchFormatted: true
      }}
      exportCSV={{ fileName: "invoices.csv" }}
    >
      {props => (
        <div>
          <Row>
            <Col>
              <div className="customSearch">
                <Input
                  placeholder="Search..."
                  value={searchQuery.query}
                  style={{ marginBottom: 10 }}
                  onChange={e => searchQuery.setQuery(e.target.value)}
                  disabled={disabled}
                />
              </div>
            </Col>
            {
              currentUser?.is_premium_user && <SubUserFilterCustom subUserData={subUserData} />
            }
            <Col>
              <div className="flexEndContainer">
                <ExportCSVButton className="btn btn-outline-info" {...props.csvProps} disabled={disabled}>
                  Export CSV
                </ExportCSVButton>
              </div>
            </Col>
          </Row>
          <BootstrapTable
            {...props.baseProps}
            bordered={false}
            remote={{ sort: true }}
            defaultSorted={defaultSorted}
            onTableChange={handleTableChange}
            disabled={disabled}
          />
        </div>
      )}
    </ToolkitProvider>
  );
};

export default SubuserInvoiceAdminViewTable;
